import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightMode from '@mui/icons-material/LightMode';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import React from 'react';
import { SetTheme, Theme } from './types';

type Props = {
	theme: Theme;
	setTheme: SetTheme;
};

export default ({ theme, setTheme }: Props) => (
	<ToggleButtonGroup
		size="small"
		color="primary"
		value={theme}
		exclusive
		onChange={(_, v) => v && setTheme(v)}
	>
		<ToggleButton value="light">
			<LightMode />
		</ToggleButton>
		<ToggleButton value="dark">
			<DarkModeOutlinedIcon />
		</ToggleButton>
	</ToggleButtonGroup>
);
